// packages
import { capfirst, intcomma } from 'journalize';
import { Component, h } from 'preact';

// components
import CountyTable from './CountyTable';

// internal
import { sort_candidates_by_party } from '../election-utils';
import sumValues from '../utils/sum-values';

type Props = {
  contest: { [key: string]: any };
  columnCount: number;
  contestTitle: string;
  includeCountyRundown?: boolean;
  renderCandidate: any;
  tableHeader: JSX.Element;
  visibleCandidatesCount?: number;
};

class Contest extends Component<Props> {
  render() {
    const {
      contest,
      columnCount,
      contestTitle,
      includeCountyRundown,
      renderCandidate,
      tableHeader,
    } = this.props;

    const shouldDisplayResult =
      contest.is_called && contest.result !== 'not called';

    const isStatewide = contest.division_type === 'statewide';
    const totalVotes = sumValues(contest.candidates, 'votes');

    let candidates = contest.candidates;

    if (totalVotes <= 0) {
      candidates = sort_candidates_by_party(candidates);
    }

    return (
      <div class="contest">
        <table class="contest__candidates">
          <caption class="contest__caption">
            <p class="contest__caption-title">{contestTitle}</p>
          </caption>
          {tableHeader}
          <tbody>
            {shouldDisplayResult && (
              <tr class="contest__called-row">
                <td colSpan={columnCount}>{`Projected ${contest.result}`}</td>
              </tr>
            )}
            {candidates.map((candidate: any) =>
              renderCandidate(candidate, { totalVotes })
            )}
          </tbody>
        </table>
        <div class="contest__metrics">
          <p class="contest__precincts">
            {`${intcomma(contest.precincts_reporting)} of ${intcomma(
              contest.total_precincts
            )} precincts reporting (${contest.precincts_reporting_percent.toFixed(
              1
            )}%)`}
          </p>
        </div>
        {includeCountyRundown && (
          <CountyTable
            candidates={contest.candidates}
            counties={contest.counties}
            visibleRows={isStatewide ? 10 : 5}
          />
        )}
      </div>
    );
  }
}

Contest.defaultProps = {
  includeCountyRundown: false,
  visibleCandidatesCount: 3,
};

export default Contest;
